export const transactionsSelector = state => state.transactionReducer.transactions;

export const loadingTransactionsSelector = state => state.transactionReducer.loadingTransactions;
